/**
 * main.tsx
 *
 * Entry point for Via Logos web application
 * Uses standard ReactDOM instead of react-native-web
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
